import "react-multi-carousel/lib/styles.css";
import { getJustifiedContentValue } from "./cardLayoutUtils";
/**
 * useCardLayout - Calculates the number of columns to display for a breakpoint in Grid view
 * @param screenXS - Cards to show on extra small screens
 * @param screenSM - Cards to show on small screens
 * @param screenMD - Cards to show on medium screens
 * @param screenLG  - Cards to show on large screens
 * @param cardsToRender = The number of cards available and to be rendered by the module.
 * @returns Number of columns to display for a given breakpoint
 */
export const useCardLayout = (screenXS, screenSM, screenMD, screenLG, cardsToRender, CenterCards) => {
    // These are the user's settings before being converted to MUI Grid sizing.
    const userDefinedCardsPerRow = {
        xs: screenXS,
        sm: screenSM,
        md: screenMD,
        lg: screenLG,
    };
    // These are the cards per row converted to MUI Grid sizing.
    // const cardsPerRowGridSizes = {
    //   xs: (12 / Number(screenXS)) as boolean | GridSize | undefined,
    //   sm: (12 / Number(screenSM)) as boolean | GridSize | undefined,
    //   md: (12 / Number(screenMD)) as boolean | GridSize | undefined,
    //   lg: (12 / Number(screenLG)) as boolean | GridSize | undefined,
    // };
    const cardsPerRowGridSizes = {
        xs: 12 / Number(screenXS),
        sm: 12 / Number(screenSM),
        md: 12 / Number(screenMD),
        lg: 12 / Number(screenLG),
    };
    const justifyContent = CenterCards
        ? getJustifiedContentValue(Object.assign({ cardsToRender }, userDefinedCardsPerRow))
        : "flex-start";
    return Object.assign(Object.assign({}, cardsPerRowGridSizes), { justifyContent });
};
